import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import LineItemSummary from '@/components/receipt/details/LineItemSummary';
import LineItemEnrichDetails from '@/components/receipt/details/LineItemEnrichDetails';
import { components } from '@/types/api';
import { formatCategory } from '@/lib/utils';
import useOpenApiClient from '@/hooks/useOpenApiClient';

type LineItem = components['schemas']['LineItem'];
interface ReceiptViewProps {
  lineItem: LineItem | null;
  onClose: () => void;
}

export default function LineItemDetailsSheet({ lineItem, onClose }: ReceiptViewProps) {
  const { userRole } = useOpenApiClient();
  return (
    <Sheet open={Boolean(lineItem)} onOpenChange={onClose}>
      {lineItem && (
        <SheetContent
          side="bottom"
          className="no-scrollbar max-h-screen overflow-y-auto bg-white px-8 pt-4 pb-7"
        >
          <SheetHeader className="space-y-1 text-left">
            <SheetTitle className="flex items-center justify-between py-6">
              <span className="text-foreground text-2xl font-thin">{lineItem.description}</span>
            </SheetTitle>
            {lineItem.product_code && (
              <p className="text-foreground pb-4 text-lg leading-4 font-normal opacity-70">
                Product code: {lineItem.product_code}
              </p>
            )}
            {lineItem.category && (
              <p className="text-foreground text-sm leading-4 font-normal opacity-70">
                Category: {formatCategory(lineItem.category)}
              </p>
            )}
            <div className="py-4">
              <LineItemSummary lineItem={lineItem} />
            </div>
            {userRole !== 'live' && (
              <>
                {lineItem.line_item_benefits && lineItem.line_item_benefits.length && (
                  <span className="text-foreground pb-2 text-base font-bold">BENEFITS DETAIL</span>
                )}
                <LineItemEnrichDetails benefitTotals={lineItem.line_item_benefits} />
              </>
            )}
          </SheetHeader>
        </SheetContent>
      )}
    </Sheet>
  );
}
